// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EnumClusterState = {
  ClusterStateUnknown: 'UNKNOWN',
  ClusterStateCreating: 'CREATING',
  ClusterStateUpdating: 'UPDATING',
  ClusterStateRunning: 'RUNNING',
  ClusterStateScaledDown: 'SCALED_DOWN',
  ClusterStateError: 'ERROR',
} as const;
export type EnumClusterState =
  (typeof EnumClusterState)[keyof typeof EnumClusterState];

export function instanceOfEnumClusterState(value: any): boolean {
  for (const key in EnumClusterState) {
    if (Object.prototype.hasOwnProperty.call(EnumClusterState, key)) {
      if (EnumClusterState[key as keyof typeof EnumClusterState] === value) {
        return true;
      }
    }
  }
  return false;
}

export function EnumClusterStateFromJSON(json: any): EnumClusterState {
  return EnumClusterStateFromJSONTyped(json, false);
}

export function EnumClusterStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnumClusterState {
  return json as EnumClusterState;
}

export function EnumClusterStateToJSON(value?: EnumClusterState | null): any {
  return value as any;
}

export function EnumClusterStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EnumClusterState {
  return value as EnumClusterState;
}
